import LeaveAdjustmentTypes from './LeaveAdjustment.types';

// ========== GET EMPLOYEE LEAVE BALANCE ACTIONS START ==========
export const getEmployeeLeaveBalanceStart = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_START,
	payload: data,
});

export const getEmployeeLeaveBalanceSuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_SUCCESS,
	payload: data,
});

export const getEmployeeLeaveBalanceFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_FAILURE,
	payload: error,
});
// ========== GET EMPLOYEE LEAVE BALANCE ACTIONS END ==========

// ========== CREATE LEAVE ADJUSTMENT ACTIONS START ==========
export const createLeaveAdjustmentStart = (data: any) => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_START,
	payload: data,
});

export const createLeaveAdjustmentSuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_SUCCESS,
	payload: data,
});

export const createLeaveAdjustmentFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_FAILURE,
	payload: error,
});

export const createLeaveAdjustmentResponseReset = () => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_RESPONSE_RESET,
});
// ========== CREATE LEAVE ADJUSTMENT ACTIONS END ==========

